import React from "react";

const Index = ({ children }) => {
  return <div className="index">{children}</div>;
};

export default Index;
